import * as functions from '../payment/functions.js'
import axios from 'axios'
import * as vars from '@/vars.json'
import router from '@/router.js'

const httpAxios = axios.create({
  params: {},
})

const loginPage = '/pages/login'

export const pos = {
  namespaced: true,
  state: {
    cart: [],
  },
  mutations: {
    ADD_AMOUNT (state, { index1, index2, idShop, newAmount, hasMagnitude }) {
      const amount = state.cart[index1].inventory[index2].amount
      let decimals
      if (hasMagnitude) {
        decimals = 1
      } else {
        decimals = 0
      }
      const diffAmount = Math.abs((parseFloat(newAmount) - parseFloat(amount)).toFixed(decimals))
      const stock = (parseFloat(state.cart[index1].inventory[index2].data.location[idShop].stock) - parseFloat(diffAmount)).toFixed(decimals)
      if (stock >= 0) {
        state.cart[index1].inventory[index2].amount = (parseFloat(newAmount)).toFixed(decimals)
        state.cart[index1].inventory[index2].data.newAmount = (parseFloat(newAmount)).toFixed(decimals)
        state.cart[index1].inventory[index2].data.location[idShop].stock = stock
      } else {
        if (hasMagnitude) {
          state.cart[index1].inventory[index2].amount = (parseFloat(amount) + parseFloat(state.cart[index1].inventory[index2].data.location[idShop].stock)).toFixed(1)
          state.cart[index1].inventory[index2].data.newAmount = (parseFloat(amount) + parseFloat(state.cart[index1].inventory[index2].data.location[idShop].stock)).toFixed(1)
          state.cart[index1].inventory[index2].data.location[idShop].stock = 0
        }
      }
    },
    ADD_TO_CART (state, payload) {
      let stock = 0
      if (payload.context === 'order') {
        stock = payload.inventory.data.location[payload.id].stock
      } else {
        stock = payload.inventory.data.location.stock
      }
      if (stock >= 0) {
        // console.log(payload)
        /* const shop = {
          id: payload.id,
          uid: payload.uid,
          name: payload.name,
          pictures: payload.pictures,
          addressInfo: payload.addressInfo,
          minOrderValue: payload.minOrderValue,
          inventory: [],
        } */
        const shop = {
          ...payload,
        }
        shop.inventory = []
        let cont = 0
        let ban = true
        while (ban && cont < state.cart.length) {
          if (shop.id === state.cart[cont].id) {
            payload.inventory.amount = 1
            payload.inventory.data.newAmount = 1
            payload.inventory.data.validInputAmount = true
            state.cart[cont].inventory.push(payload.inventory)
            ban = false
          }
          cont++
        }
        // console.log(ban)
        if (ban) {
          payload.inventory.amount = 1
          payload.inventory.data.newAmount = 1
          payload.inventory.data.validInputAmount = true
          shop.inventory.push(payload.inventory)
          state.cart.push(shop)
        }
      }
    },
    CLEAR_CART (state) {
      state.cart = []
    },
    QUIT_AMOUNT (state, { index1, index2, idShop, newAmount, hasMagnitude }) {
      const amount = state.cart[index1].inventory[index2].amount
      let decimals
      if (hasMagnitude) {
        decimals = 1
      } else {
        decimals = 0
      }
      const diffAmount = Math.abs((parseFloat(newAmount) - parseFloat(amount)).toFixed(decimals))
      const stock = (parseFloat(state.cart[index1].inventory[index2].data.location[idShop].stock) + parseFloat(diffAmount)).toFixed(decimals)
      state.cart[index1].inventory[index2].amount = (parseFloat(newAmount)).toFixed(decimals)
      state.cart[index1].inventory[index2].data.newAmount = (parseFloat(newAmount)).toFixed(decimals)
      state.cart[index1].inventory[index2].data.location[idShop].stock = stock
      if (state.cart[index1].inventory[index2].amount < 1) {
        state.cart[index1].inventory.splice(index2, 1)
        if (state.cart[index1].inventory.length === 0) {
          state.cart.splice(index1, 1)
        }
      }
    },
  },
  actions: {
    addToCart ({ commit, state }, payload) {
      let found = true
      let cont = 0
      while (found && cont < state.cart.length) {
        for (let i = 0; i < state.cart[cont].inventory.length; i++) {
          if (payload.inventory.id === state.cart[cont].inventory[i].id) {
            found = false
          }
        }
        cont++
      }
      if (found) {
        if (payload.inventory.data.type !== 'service') {
          let stock = 0
          if (payload.context === 'order') {
            stock = parseFloat(payload.inventory.data.location[payload.id].stock) - 1
            payload.inventory.data.location[payload.id].stock = stock
          } else {
            stock = parseFloat(payload.inventory.data.location.stock) - 1
            payload.inventory.data.location.stock = stock
          }
        }
        commit('ADD_TO_CART', {
          ...payload,
        })
      }
    },
    addAmount ({ commit, state }, index) {
      commit('ADD_AMOUNT', index)
    },
    quitAmount ({ commit, state }, index) {
      commit('QUIT_AMOUNT', index)
    },
    clearCart ({ commit }) {
      commit('CLEAR_CART')
    },
    removeOrder ({ state }, cart) {
      let cont = 0
      let ban = true
      while (ban && cont < state.cart.length) {
        if (state.cart[cont].id === cart.id) {
          state.cart.splice(cont, 1)
          ban = false
        }
        cont++
      }
    },
    stateCashRegister ({ rootState }, data) {
      return new Promise((resolve, reject) => {
        httpAxios.post(vars.url + '/stateCashRegister', data).then((response) => {
          resolve(response.data)
        }).catch((error) => {
          reject(error)
        })
      })
    },
    sendOrder ({ rootState }, data) {
      return new Promise((resolve, reject) => {
        if (rootState.users.profile) {
          // const direction = rootState.users.profile.direction
          // let directionOrder = ''
          // const space = ' '
          /* if (rootState.users.profile.defaultlocation && rootState.users.profile.defaultlocation.direction) {
            directionOrder = rootState.users.profile.defaultlocation
          } else {
            directionOrder = direction.street.concat(space, direction.address, space, direction.city, space, direction.state)
          } */
          data.data.client.id = rootState.users.user.uid
          data.data.client.send = false
          data.data.client.phone = rootState.users.profile.phone
          data.data.client.fullName = rootState.users.profile.name + ' ' + rootState.users.profile.last_name
          data.data.user = {
            id: data.uid,
          }
          // console.log(data)
          data = functions.encrypt(data)
          httpAxios.post(vars.url + '/sendOrder', data).then((response) => {
            response.data = functions.decrypt(response.data)
            resolve(response)
          }).catch((error) => {
            reject(error)
          })
        } else {
          router.push(loginPage)
        }
      })
    },
  },
  getters: {
    getCart (state) {
      return state.cart
    },
    getCartTotal (state) {
      let total = 0
      state.cart.forEach(function (item) {
        total = total + parseInt(item.amount * item.price.sale)
      })
      return total
    },
  },
}
